// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","ProBadge":"bec_a bhk_rh bhk_ri bhk_vf bhk_ec bhk_vc bhk_gs bhk_kf"};